import { Tag } from "primereact/tag";
import { Steps } from "primereact/steps";
import { phases } from "../constants";
import { SyncStepsProps } from "./types";

export function SyncSteps({ currentPhaseIndex }: SyncStepsProps) {
  const items = phases.map((p, i) => ({
    label: p.label,
    template: () => (
      <span
        className={`flex align-items-center gap-2 ${
          i <= currentPhaseIndex ? "text-primary" : "text-500"
        }`}
      >
        <i className={p.icon} />
        {p.label}
        {i < currentPhaseIndex && <Tag value="OK" severity="success" rounded />}
      </span>
    ),
  }));

  return (
    <div className="overflow-x-auto">
      <Steps model={items} activeIndex={currentPhaseIndex} readOnly />
    </div>
  );
}
